import Badge from '@components/Badge'
import { StoreProps } from '@interfaces/StoreState'
import { Inline } from '@layouts/Scheduling/SchedulingLayout/style'
import isNumber from 'lodash/isNumber'
import Link from 'next/link'
import React from 'react'
import { useSelector } from 'react-redux'

const PendingLessonsTab: React.FC<{ item: any }> = ({ item }) => {
  const { pendingLessonCount, loading, error } = useSelector(({ pendingLessons }: StoreProps) => pendingLessons)

  return (
    <Link href={item.link} legacyBehavior>
      <Inline>
        {item.child}{' '}
        {!error && (
          <div className="badge">
            <Badge
              blink={loading}
              label={loading ? '' : pendingLessonCount?.toString()}
              isNumber={isNumber(pendingLessonCount)}
              circle
            />
          </div>
        )}
      </Inline>
    </Link>
  )
}

export default PendingLessonsTab
